<div class="container m-5">
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between">
        <span class="h3">Lista de empleados</span>
        <button class="btn btn-dark btn-lg float-rigth" routerLink="/create">
          Agregar
        </button>
      </div>
      <h5 *ngIf="empleados.length == 0" class="mt-5">
        No hay empleados registrados
      </h5>
      <div class="my-5">
        <input
          type="text"
          class="form-control mb-4"
          placeholder="Search"
          [(ngModel)]="filter"
          id="listSearch"
        />
      </div>
      <table class="table mt-5" *ngIf="empleados.length > 0">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Apellido</th>
            <th scope="col">Documento</th>
            <th scope="col">Salario</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let i of empleados | filter: filter">
            <td>{{ i.nombre }}</td>
            <td>{{ i.apellido }}</td>
            <td>{{ i.documento }}</td>
            <td>{{ i.salario | currency }}</td>
            <td class="d-flex align-items-center">
              <span
                class="material-icons-outlined mr-3 text-info"
                [routerLink]="['/edit', i.id]"
              >
                rate_review </span
              ><span
                class="material-icons-outlined text-danger"
                (click)="eliminarEmpleado(i.id)"
              >
                delete
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
